import { getDealerById } from "../constants/apiCalls";
import ModalService from "../services/ModalService";
import { handleErrorMessage } from "../utils/utils";

// Type
export const DEALER_DETAIL = `DEALER_DETAIL`;

// Action
// export const dealerInfoAction = (data) => {
//     return {
//         type: DEALER_DETAIL,
//         data
//     }
// }
export const dealerInfoAction = (id, setIsloading) => dispatch => {
    getDealerById((res) => {
        const { success, data, error } = res;
        if (success === true) {
            if(data && data.length > 0){
                dispatch({
                    type: DEALER_DETAIL,
                    data: data[0]
                })
            } else{
                dispatch({
                    type: DEALER_DETAIL,
                    data: {}
                })
            }
            setIsloading(false);
        } else if (success === false || success === 'undefined') {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            setIsloading(false);
            dispatch({
                type: DEALER_DETAIL,
                data: {}
            })
        }
        setIsloading(false);
    }, id);
}


// Reducer

const initState = {
    dealerObj: {}
}

const DealerReducer = (state = initState, action) => {
    switch (action.type) {
        case DEALER_DETAIL:
            return {
                ...state,
                dealerObj: action.data
            }

        default: return state;
    }
}
export default DealerReducer;